import { create } from "zustand";
import { persist } from 'zustand/middleware';

const useWaiverStore = create(
  persist((set, get) => ({
    waivers: [],
    setWaivers: (value) => set({ waivers: value }),
    updateWaiver: (updatedWaiver) => set((state) => ({
      waivers: state.waivers.map((waiver) => waiver.id === updatedWaiver.id ? { ...waiver, ...updatedWaiver } : waiver)
    })),
    addWaiver: (waiver) => set((state) => ({
      waivers: [...state.waivers, waiver]
    })),
    removeWaiver: (waiver) => set((state) => ({
      waivers: state.waivers.filter((page) => page.id !== waiver.id)
    })),
    waiverById: (id) => get().waivers.find((o) => o.id == id),
  }), {
    name: 'waiver-storage', // unique name
  })
);

export default useWaiverStore;